import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/data/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-secondary-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <Link to="/" className="font-heading text-xl font-semibold text-foreground-900 whitespace-nowrap">
              Kakobuy<span className="text-primary-500">Polska</span>Wiki
            </Link>
            <p className="mt-3 text-xs md:text-sm text-foreground-600 max-w-xs leading-relaxed">
              Największa polska baza wiedzy o Kakobuy Spreadsheet. Pomagamy użytkownikom z Polski znaleźć najlepsze produkty, sprawdzić informacje i bezpieczniej korzystać z Kakobuy.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-xs text-foreground-800 uppercase tracking-wider mb-4">
              Kategorie
            </h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-xs text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-xs text-foreground-800 uppercase tracking-wider mb-4">
              Więcej
            </h4>
            <ul className="space-y-2">
              {categories.slice(6, 12).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-xs text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-xs text-foreground-800 uppercase tracking-wider mb-4">
              Linki
            </h4>
            <ul className="space-y-2">
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  Kakobuy Spreadsheet
                </a>
              </li>
              <li>
                <Link to="/artykul/kakobuy-spreadsheet-polska-kompletny-przewodnik" className="text-xs text-foreground-600 hover:text-primary-600 transition-colors">
                  Przewodnik
                </Link>
              </li>
              <li>
                <a href="#faq" className="text-xs text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  FAQ
                </a>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 Kakobuy Polska Wiki. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-6">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">
              Privacy
            </a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">
              Terms
            </a>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">
              Disclaimer
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}